import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=5fb9b33c&scoped=true&"
import script from "./AddressInput.vue?vue&type=script&lang=ts&"
export * from "./AddressInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb9b33c",
  null
  
)

export default component.exports